import { ButtonDivIcon } from '../../../Shared/Map/markers/button-div-icon';
import { TranslationService } from '../../../../services/translation.service';
import { MarkerCluster } from 'leaflet';

export default class StopAreaClusterDivIcon extends ButtonDivIcon {
  constructor(cluster: MarkerCluster) {
    super(
      {
        className: 'marker-cluster cluster-div-icon',
        html: `<div><span>${cluster.getChildCount()}</span></div>`,
      },
      `${TranslationService.get('stopareasearchpage.clusterwith')} ${cluster.getChildCount()} ${TranslationService.get('common.stops').toLocaleLowerCase()}`
    );
  }
}
